import styled from '@emotion/styled'
import { Row } from 'react-bootstrap'

export const ActionButtonRow = styled(Row)`
  label: ActionButtonRow;
  justify-content: center;
  width: 100%;
  margin-bottom: 1rem !important;
  margin-right: 0px;
  margin-left: 0px;
  @media (max-width: 719px) {
    flex-direction: column;
    align-items: center;
  }
`

export const EmissionContainer = styled('div')`
  label: emissionContainer;
  padding-bottom: 30px;
`


export const FeatureBlockContainer = styled('div')`
  label: FeatureBlockContainer;
  max-width: ${(props) => props.maxWidth};
  background-color: inherit;
`

export const FeatureBlockHeader = styled('div')`
  label: FeatureBlockHeader;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 700)};
  font-size: 18px;
  color: ${(props) => props.theme.colors.cardHeaderFontColor};
  line-height: 42px;
  text-transform: uppercase;
`

export const FeatureBlockContent = styled('div')`
  label: FeatureBlockContent;
  color: ${(props) => props.theme.colors.grey2};
  display: flex;
  align-items: baseline;
  font-size: 18px;
  > img {
    height: 14px;
    padding-right: 6px;
  }
`
